/* =========================
    IMPORTS & CORE PACKAGES
   ========================= */
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

/* ====================================
    CONFIGURATION & APP INITIALIZATION
   ==================================== */

/* Load Environment Variables */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

/* Initialize Firebase App Instance */
const app = initializeApp(firebaseConfig);

/* ==========================
    CORE EXPORTABLE SERVICES
   ========================== */

/* Export Auth, DB, and Storage Instances */
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);